import { EVENT_TYPE } from '@hedepy/common/enums/EVENT_TYPE'

import useRebookEvent from '@/legacy-src/components/reservation/hooks/useRebookEvent'

import { FreeSlotTypeFilter } from '@/src/domains/client-booking/constants'

const freeSlotTypeFilterByEventType: Record<EVENT_TYPE, FreeSlotTypeFilter> = {
  [EVENT_TYPE.ONLINE]: FreeSlotTypeFilter.ONLINE,
  [EVENT_TYPE.OFFLINE]: FreeSlotTypeFilter.OFFLINE,
}

export const useClientBookingRebookFreeSlotTypeFilter = () => {
  const { isRebookingInProgress, originalEventData } = useRebookEvent()

  const rebookingEventFilter =
    isRebookingInProgress && originalEventData !== undefined
      ? freeSlotTypeFilterByEventType[originalEventData.type]
      : undefined

  return rebookingEventFilter
}
